import hdracesService from '../services/hdraces.service'

const handlers = {
  hdraces: {
    session: {
      set: 'hdraces_session_set'
    }
  }
}

const initVuexState = function(state) {
  state.hdraces = {
    session: null
  };
}

const initGetters = function(getters) {
  getters.hdraces = (state => state.hdraces);
}

const initActions = function(actions) {
  actions[handlers.hdraces.session.set] = ({ commit }, session) => commit(handlers.hdraces.session.set, session);
}

const initMutations = function(mutations) {
  mutations[handlers.hdraces.session.set] = (state, session) => state.hdraces.session = session;
}

const initAppState = function(appState, store) {
  appState.hdraces = {
    session: {
      get: () => store.getters.hdraces.session,
      open: async (gameId, language, isMobile, backUrl, showBalance) => {
        let session = await hdracesService.openSession(gameId, language, isMobile, backUrl, showBalance);
        store.dispatch(handlers.hdraces.session.set, session);
      },
      openDemo: async (gameId, language, isMobile, backUrl, showBalance) => {
        let session = await hdracesService.openDemoSession(gameId, language, isMobile, backUrl, showBalance);
        store.dispatch(handlers.hdraces.session.set, session);
      },
      close: async () => {
        if (store.getters.hdraces.session) {
          await hdracesService.closeSession(store.getters.hdraces.session.sessionId);
        }
        store.dispatch(handlers.hdraces.session.set, null);
      }
    }
  }
}

export default {
  initVuex(vuexState, getters, actions, mutations) {
    initVuexState(vuexState);
    initGetters(getters);
    initActions(actions);
    initMutations(mutations);
  },
  initAppState(appState, store) {
    initAppState(appState, store);
  }
}



// WEBPACK FOOTER //
// ./_common/data/hdraces.js